import { render, staticRenderFns } from "./StockPrintPkgTicketTpl.vue?vue&type=template&id=6874f3da&scoped=true&"
import script from "./StockPrintPkgTicketTpl.vue?vue&type=script&lang=js&"
export * from "./StockPrintPkgTicketTpl.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintPkgTicketTpl.vue?vue&type=style&index=0&id=6874f3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874f3da",
  null
  
)

export default component.exports